import styled from "vue-styled-components";

export const StyleHorary = styled.div`
    position: relative;
    height: auto;
    width: auto;
    max-width: 300px;
    padding: 1rem;
    border: 1px solid ${props => props.theme?.calendar?.border_color ?? props.theme?.border_color_site ?? '#dee2e6'};
    background: ${props => props.theme?.background_color_site ?? '#fff'};

    .modal-delivery-time-header {
        border-bottom: 1px solid ${props => props.theme?.calendar?.border_color ?? props.theme?.border_color_site ?? '#dee2e6'};
        padding-bottom: 1rem;

        h2 {
            color: ${props => props.theme?.calendar?.header?.color ?? props.theme?.text_site_color ?? '#4a505e'};
            font-size: ${props => props.theme?.calendar?.header?.font_size ?? '1.3rem'};
            font-weight: ${props => props.theme?.calendar?.header?.font_weight ?? '600'};
            letter-spacing: 0.5px;
            text-transform: ${props => props.theme?.calendar?.header?.text_transform ?? 'uppercase'};
            margin-block: 0.5rem;
        }
    }

    ul {
        margin-block: 1rem;

        li + li {
            margin-top: 0.5rem;
        }

        li {          
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 1rem;

            .checkbox {
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #ddd;
                width: 2rem;
                height: 2rem;
            }
            
            span {
                font-size: ${props => props.theme?.calendar?.body?.day?.font_size ?? '1.3rem'};
                font-weight: ${props => props.theme?.calendar?.body?.day?.font_weight ?? '400'};
                color: ${props => props.theme?.calendar?.body?.day?.color ?? props.theme?.text_site_color ?? '#4a505e'};
            }
        }
    }

    .modal-delivery-time-footer {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
        border-top: 1px solid ${props => props.theme?.calendar?.border_color ?? props.theme?.border_color_site ?? '#dee2e6'};
        padding-top: 1rem;
    }
`;
